import Vue from "vue";
import ApiService from "@/common/api.service";
import { API_PATH } from "@/common/config";

const PATH = "deal-types";

export const GET_DEAL_TYPES = "getDealTypes";
export const GET_DEAL_TYPE = "getDealType";
export const GET_DEAL_TYPE_OPTIONS = "getDealTypeOptions";
export const STORE_DEAL_TYPE = "storeDealType";
export const UPDATE_DEAL_TYPE = "updateDealType";
export const DELETE_DEAL_TYPE = "deleteDealType";

const actions = {
  [GET_DEAL_TYPES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [GET_DEAL_TYPE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [GET_DEAL_TYPE_OPTIONS](context) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, "options")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [STORE_DEAL_TYPE](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [UPDATE_DEAL_TYPE](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, params.id, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [DELETE_DEAL_TYPE](context, id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(`${API_PATH}${PATH}/${id}`)
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error?.response?.data ?? error);
        });
    });
  },
};

export default {
  actions,
};
